import React, { Component } from "react";
import FileUpload from "../common/FileUpload";
import { SubmitImg } from "../common/Converter";
import TextStyler from "../TextStyler/TextStyler";

class PayrollHeader extends Component {
  constructor(props) {
    super(props);
    const header = props.header || props;
    this.state = {
      leftLogo: header.leftLogo || [],
      rightLogo: header.rightLogo || [],
      topTitle: header.topTitle || "Republic Of the Philippines",
      mainTitle: header.mainTitle || "BUREAU OF IMMIGRATION",
      motto: header.motto || "Patriotism * Integrity * Professionalism",
      topTitleStyle: header.topTitleStyle || { color: "#000000", fontSize: 16, bold: false, italic: false },
      mainTitleStyle: header.mainTitleStyle || { color: "#000000", fontSize: 32, bold: true, italic: false },
      mottoStyle: header.mottoStyle || { color: "#000000", fontSize: 14, bold: false, italic: false },
      leftLogoPosition: header.leftLogoPosition !== undefined ? header.leftLogoPosition : 110,
      rightLogoPosition: header.rightLogoPosition !== undefined ? header.rightLogoPosition : 120,
      leftLogoSize: header.leftLogoSize !== undefined ? header.leftLogoSize : 120,
      rightLogoSize: header.rightLogoSize !== undefined ? header.rightLogoSize : 120,
      topTitleMarginBottom: header.topTitleMarginBottom !== undefined ? header.topTitleMarginBottom : 0,
      mottoMarginTop: header.mottoMarginTop !== undefined ? header.mottoMarginTop : 0,
    };
    this.debounceTimer = null;
    this.objectURLs = [];
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      // Support both individual props and header object prop
      const header = this.props.header || this.props;
      this.setState({
        leftLogo: header.leftLogo || [],
        rightLogo: header.rightLogo || [],
        topTitle: header.topTitle || "Republic Of the Philippines",
        mainTitle: header.mainTitle || "BUREAU OF IMMIGRATION",
        motto: header.motto || "Patriotism * Integrity * Professionalism",
        topTitleStyle: header.topTitleStyle || { color: "#000000", fontSize: 16, bold: false, italic: false },
        mainTitleStyle: header.mainTitleStyle || { color: "#000000", fontSize: 32, bold: true, italic: false },
        mottoStyle: header.mottoStyle || { color: "#000000", fontSize: 14, bold: false, italic: false },
        leftLogoPosition: header.leftLogoPosition !== undefined ? header.leftLogoPosition : 110,
        rightLogoPosition: header.rightLogoPosition !== undefined ? header.rightLogoPosition : 120,
        leftLogoSize: header.leftLogoSize !== undefined ? header.leftLogoSize : 120,
        rightLogoSize: header.rightLogoSize !== undefined ? header.rightLogoSize : 120,
        topTitleMarginBottom: header.topTitleMarginBottom !== undefined ? header.topTitleMarginBottom : 0,
        mottoMarginTop: header.mottoMarginTop !== undefined ? header.mottoMarginTop : 0,
      });
    }
  }

  componentWillUnmount() {
    this.objectURLs.forEach((url) => URL.revokeObjectURL(url));
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  _handleChange = async (field, value) => {
    if (field === "leftLogo" || field === "rightLogo") {
      this.setState({ [field]: value });

      try {
        const urls = await SubmitImg(value);
        
        this.setState({ [field]: urls }, () => {
          if (this.props.onChange) {
            this.props.onChange(this.state);
          }
        });
      } catch (error) {
        console.error(`Failed to upload ${field}:`, error);
      }
      return;
    }

    // Handle position and size inputs (immediate update)
    if (field === "leftLogoPosition" || field === "rightLogoPosition" || 
        field === "leftLogoSize" || field === "rightLogoSize" ||
        field === "topTitleMarginBottom" || field === "mottoMarginTop") {
      this.setState({ [field]: value }, () => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      });
      return;
    }

    // Handle text inputs (debounced)
    if (typeof value === "string") {
      this.setState({ [field]: value });
      
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      }, 300);
    } 
    // Handle style objects (immediate update)
    else if (typeof value === "object" && value !== null) {
      this.setState({ [field]: value }, () => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      });
    }
  };

  getImageSrc = (file) => {
    if (!file) {
      return "";
    }
    
    if (typeof file === "string") {
      return file;
    }
    
    if (!(file instanceof Blob) && !(file instanceof File)) {
      console.warn("Invalid file type in getImageSrc:", file);
      return "";
    }
    
    try {
      const url = URL.createObjectURL(file);
      this.objectURLs.push(url);
      return url;
    } catch (error) {
      console.error("Failed to create object URL:", error);
      return "";
    }
  };

  render() {
    const {
      leftLogo,
      rightLogo,
      topTitle,
      mainTitle,
      motto,
      topTitleStyle,
      mainTitleStyle,
      mottoStyle,
      leftLogoPosition,
      rightLogoPosition,
      leftLogoSize,
      rightLogoSize,
      topTitleMarginBottom,
      mottoMarginTop,
    } = this.state;
    const { disabled, showInputs = true } = this.props;

    return (
      <div className="payroll-header-container border rounded p-2">
        {showInputs && (
          <div className="mb-4">
            <h5 className="mb-3">Header Configuration</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Left Logo</label>
                  <FileUpload
                    attachments={leftLogo}
                    onFileChange={(files) => this._handleChange("leftLogo", files)}
                    disabled={disabled}
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                    label="Left Logo"
                    maxFiles={1}
                  />
                  <label className="form-label mt-2">Left Logo Position (px)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.leftLogoPosition}
                    onChange={(e) =>
                      this._handleChange("leftLogoPosition", parseInt(e.target.value) || 0)
                    }
                    disabled={disabled}
                    placeholder="110"
                    min="0"
                  />
                  <label className="form-label mt-2">Left Logo Size (px)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.leftLogoSize}
                    onChange={(e) =>
                      this._handleChange("leftLogoSize", parseInt(e.target.value) || 0)
                    }
                    disabled={disabled}
                    placeholder="120"
                    min="20"
                    max="300"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Right Logo</label>
                  <FileUpload
                    attachments={rightLogo}
                    onFileChange={(files) => this._handleChange("rightLogo", files)}
                    disabled={disabled}
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                    label="Right Logo"
                    maxFiles={1}
                  />
                  <label className="form-label mt-2">Right Logo Position (px)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.rightLogoPosition}
                    onChange={(e) =>
                      this._handleChange("rightLogoPosition", parseInt(e.target.value) || 0)
                    }
                    disabled={disabled}
                    placeholder="120"
                    min="0"
                  />
                  <label className="form-label mt-2">Right Logo Size (px)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.rightLogoSize}
                    onChange={(e) =>
                      this._handleChange("rightLogoSize", parseInt(e.target.value) || 0)
                    }
                    disabled={disabled}
                    placeholder="120"
                    min="20"
                    max="300"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label">Top Title</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={topTitle}
                  onChange={(e) =>
                    this._handleChange("topTitle", e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Republic Of the Philippines"
                />
                <TextStyler
                  style={topTitleStyle}
                  onChange={(style) => this._handleChange("topTitleStyle", style)}
                  previewText={topTitle}
                  disabled={disabled}
                />
                <label className="form-label mt-2">Top Title Spacing (Bottom)</label>
                <input
                  type="number"
                  className="form-control"
                  value={this.state.topTitleMarginBottom}
                  onChange={(e) =>
                    this._handleChange("topTitleMarginBottom", parseInt(e.target.value) || 0)
                  }
                  disabled={disabled}
                  placeholder="0"
                  min="-50"
                  max="50"
                />
                <small className="text-muted">Distance from main title (px)</small>
              </div>
              
              <div className="col-md-12">
                <label className="form-label">Main Title</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={mainTitle}
                  onChange={(e) =>
                    this._handleChange("mainTitle", e.target.value)
                  }
                  disabled={disabled}
                  placeholder="BUREAU OF IMMIGRATION"
                />
                <TextStyler
                  style={mainTitleStyle}
                  onChange={(style) => this._handleChange("mainTitleStyle", style)}
                  previewText={mainTitle}
                  disabled={disabled}
                />
              </div>
              
              <div className="col-md-12">
                <label className="form-label">Motto</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={motto}
                  onChange={(e) =>
                    this._handleChange("motto", e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Patriotism * Integrity * Professionalism"
                />
                <TextStyler
                  style={mottoStyle}
                  onChange={(style) => this._handleChange("mottoStyle", style)}
                  previewText={motto}
                  disabled={disabled}
                />
                <label className="form-label mt-2">Motto Spacing (Top)</label>
                <input
                  type="number"
                  className="form-control"
                  value={this.state.mottoMarginTop}
                  onChange={(e) =>
                    this._handleChange("mottoMarginTop", parseInt(e.target.value) || 0)
                  }
                  disabled={disabled}
                  placeholder="0"
                  min="-50"
                  max="50"
                />
                <small className="text-muted">Distance from main title (px)</small>
              </div>
            </div>
          </div>
        )}

        {/* Header Preview */}
        <div className="header-preview bg-white p-4 border rounded" style={{ position: "relative", minHeight: `${Math.max(leftLogoSize, rightLogoSize, 120) + 40}px`, maxWidth: "1000px", margin: "0 auto", display: "flex", alignItems: "center" }}>
          {/* Left Logo */}
          <div
            className="logo-container"
            style={{
              position: "absolute",
              left: `${leftLogoPosition}px`,
              top: "50%",
              transform: "translateY(-50%)",
              width: `${leftLogoSize}px`,
              height: `${leftLogoSize}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {leftLogo && leftLogo.length > 0 ? (
              <img
                src={this.getImageSrc(leftLogo[0])}
                alt="Left Logo"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <div
                className="text-muted text-center"
                style={{ fontSize: "12px" }}
              >
                No Logo
              </div>
            )}
          </div>

          {/* Center Content */}
          <div className="text-center" style={{ flex: 1, padding: "10px 20px", width: "100%" }}>
              <div
                style={{
                  fontSize: `${topTitleStyle.fontSize}px`,
                  fontWeight: topTitleStyle.bold ? "bold" : "400",
                  fontStyle: topTitleStyle.italic ? "italic" : "normal",
                  color: topTitleStyle.color,
                  marginBottom: `${topTitleMarginBottom}px`,
                }}
              >
                {topTitle}
              </div>
              <div
                className="text-center"
                style={{
               
                  padding: "8px 0",
                  margin: "8px 0",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "2px",
                      backgroundColor: "#000000",
                      marginBottom: "5px",
                      marginTop: "0px"
                    }}
                  ></div>
                  <h2
                    className="mb-0"
                    style={{
                      fontSize: `${mainTitleStyle.fontSize}px`,
                      fontWeight: mainTitleStyle.bold ? "bold" : "normal",
                      fontStyle: mainTitleStyle.italic ? "italic" : "normal",
                      color: mainTitleStyle.color,
                      letterSpacing: "2px",
                    }}
                  >
                    {mainTitle}
                  </h2>
                </div>
              </div>
              <div
                style={{
                  fontSize: `${mottoStyle.fontSize}px`,
                  fontWeight: mottoStyle.bold ? "bold" : "400",
                  fontStyle: mottoStyle.italic ? "italic" : "normal",
                  color: mottoStyle.color,
                  marginTop: `${mottoMarginTop}px`,
                }}
              >
                {motto}
              </div>
            </div>

          {/* Right Logo */}
          <div
            className="logo-container"
            style={{
              position: "absolute",
              right: `${rightLogoPosition}px`,
              top: "50%",
              transform: "translateY(-50%)",
              width: `${rightLogoSize}px`,
              height: `${rightLogoSize}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {rightLogo && rightLogo.length > 0 ? (
              <img
                src={this.getImageSrc(rightLogo[0])}
                alt="Right Logo"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <div
                className="text-muted text-center"
                style={{ fontSize: "12px" }}
              >
                No Logo
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PayrollHeader;

